<template>
    <div class="play-body" v-if="klines && klines.length">
        <div class="k-draw k-draw-41">
            <div class="k-draw__bd">
                <div class="chart tabBody active" id="play__chart--1">
                    <k-candle group="play" :klines="klines" />
                </div>
            </div>
        </div>

        <div class="k-draw k-draw-42">
            <div class="k-draw__hd">
                <dl class="k-draw__tabs">
                    <dd><a class="tabItem active" href="javascript:;">成交量</a></dd>
                </dl>
                <div v-if="today" class="k-draw__opts" id="play__opts--2">
                    成交量：{{(today.volume/10000).toFixed(1)}}万手
                </div>
            </div>
            <div class="k-draw__bd">
                <k-volume group="play" :klines="klines" />
            </div>
        </div>

        <div class="k-draw k-draw-43">
            <div class="k-draw__hd">
                <dl class="k-draw__tabs">
                    <dd><a class="tabItem active" href="javascript:;">MACD</a></dd>
                </dl>
                <div class="k-draw__opts" id="play__opts--3">
                    
                </div>
            </div>
            <div class="k-draw__bd">
                <k-macd group="play" :klines="klines" />
            </div>

        </div>

        <div class="k-draw k-draw-44">
            <div class="k-draw__hd">
                <dl class="k-draw__tabs">
                    <dd><a class="tabItem active" href="javascript:;">KDJ</a></dd>
                </dl>
                <div class="k-draw__opts" id="play__opts--4">
                </div>
            </div>
            <div class="k-draw__bd">
                <k-kdj group="play" :klines="klines" />

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'play-body',
        props: ['klines', 'today']
    };

</script>
